$(document).ready(function(){
	
	// -- Init Masonry -- 
	var $grid = $('.grid').masonry({
		columnWidth: '.grid-sizer',
		itemSelector: '.grid-item',
		percentPosition: true
	});

	$grid.imagesLoaded().progress( function() {
	  $grid.masonry('layout');
	});

});